"use strict";

import {
    default as React,
    Component,
 } from 'react';
import PropTypes from 'prop-types';

import {
    XAxis,
    YAxis,
    XGrid,
    YGrid,
    Legend,
    scale
} from 'kaidoo-chart/core';

import {
    Line,
    Chart
} from 'kaidoo-chart/shape';

import CommonProps from './commonProps';

export default class LineChart extends Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        showScatter: false,
        onMouseOver: () => {},
        onMouseOut: () => {},
        ...CommonProps
    };

    static propTypes = {
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        margins: PropTypes.object.isRequired,
        data: PropTypes.array.isRequired,
        dataSeriesConfig: PropTypes.array.isRequired,
        xScaleSetConfig: PropTypes.array.isRequired,
        yScaleSetConfig: PropTypes.array.isRequired,
        lineConfig: PropTypes.object,
        legendConfig: PropTypes.object.isRequired,
    };

    render() {

        const {
            xScaleSetConfig,
            yScaleSetConfig,
            lineConfig,
            legendConfig,
            ...common
        } = this.props;

        return (
            <div>
                {legendConfig.show?
                    <Legend
                        {...common}
                        legendConfig={legendConfig}
                    />
                    : null
                }
                <Chart
                    chartShape={props => (<Line {...props}/>)}
                    xScaleSetConfig={xScaleSetConfig}
                    yScaleSetConfig={yScaleSetConfig}
                    customYScaleSetConfig={lineConfig}
                    {...common}
                >
                    {this.props.children}
                </Chart>
            </div>
        )
    }
}
